// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"JiraProjectSelector_submitBtn__3Upp0","progress":"JiraProjectSelector_progress__kFDio"};